import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { getBreadcrumbSchema } from '../components/StructuredData';

const LegalAdvise: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <SEO
        title={t('seo.legalAdvise.title')}
        description={t('seo.legalAdvise.description')}
        canonicalPath="/legal-advise"
        jsonLd={[
          getBreadcrumbSchema([
            { name: 'Home', url: '/' },
            { name: t('legalAdvise.title'), url: '/legal-advise' },
          ]),
        ]}
      />

      <Paper elevation={2} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {t('legalAdvise.title')}
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('legalAdvise.companyInfoTitle')}
          </Typography>
          <Typography paragraph>
            {t('legalAdvise.companyInfoText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('legalAdvise.termsOfUseTitle')}
          </Typography>
          <Typography paragraph>
            {t('legalAdvise.termsOfUseText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('legalAdvise.intellectualPropertyTitle')}
          </Typography>
          <Typography paragraph>
            {t('legalAdvise.intellectualPropertyText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('legalAdvise.liabilityTitle')}
          </Typography>
          <Typography paragraph>
            {t('legalAdvise.liabilityText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('legalAdvise.applicableLawTitle')}
          </Typography>
          <Typography paragraph>
            {t('legalAdvise.applicableLawText')}
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
            {t('legalAdvise.lastUpdated')}: 2023-11-01
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default LegalAdvise;
